import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CostsListItem from './CostsListItem';

const CostsList = ({ className, items, currency }) => (
  <ul className={classNames('costs-list', className)}>
    {items.map((item, index) => (
      <Fragment key={item.id}>
        <CostsListItem
          title={item.title}
          hint={item.hint}
          amount={item.amount}
          highlighted={item.highlighted}
          currency={currency}
          showItem={item.showItem}
        />
        {item.showItem && index < items.length - 1 && (
          <div className="costs-list__divider" />
        )}
      </Fragment>
    ))}
  </ul>
);

CostsList.defaultProps = {
  className: '',
  items: [],
  currency: 'USD',
};

CostsList.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      hint: PropTypes.string,
      amount: PropTypes.string,
      highlighted: PropTypes.bool,
      showItem: PropTypes.bool,
    }),
  ),
  currency: PropTypes.string,
};

export default CostsList;
